import type { ConnectionMode, Edge, HandleBounds, Position, XYPosition } from '../types';
import { getEdgeHandles } from './getHandle';
import { getHandlePoint } from './handlePoint';

/** The parts of a node an edge needs: where it is and its measured handles. */
export type EdgeEnd = { positionAbsolute: XYPosition; handleBounds: HandleBounds | null };

export type EdgePosition = {
  sourceX: number;
  sourceY: number;
  sourcePosition: Position;
  targetX: number;
  targetY: number;
  targetPosition: Position;
};

/** Endpoints and sides of an edge, or null when it cannot be drawn (missing handles — v11 skips it). */
export const getEdgePosition = (
  edge: Pick<Edge, 'sourceHandle' | 'targetHandle'>,
  source: EdgeEnd,
  target: EdgeEnd,
  connectionMode: ConnectionMode,
): EdgePosition | null => {
  const handles = getEdgeHandles(source.handleBounds, target.handleBounds, edge.sourceHandle, edge.targetHandle, connectionMode);
  if (!handles) return null;
  const sourcePoint = getHandlePoint(handles.source, source.positionAbsolute);
  const targetPoint = getHandlePoint(handles.target, target.positionAbsolute);
  return {
    sourceX: sourcePoint.x,
    sourceY: sourcePoint.y,
    sourcePosition: handles.source.position,
    targetX: targetPoint.x,
    targetY: targetPoint.y,
    targetPosition: handles.target.position,
  };
};
